export default "__VITE_ASSET__Bs9u4KgO__"